// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import RadioButton from '../../../elements/RadioButton/RadioButton';

import style from '../Filter.scss';
import icons from '../../../assets/styles/icons.scss';
import type { FilterRadioType, FilterRadioButton } from '../Filter';

type Props = {
  +filterField: FilterRadioType;
};

export default class RadioType extends Component<Props, void> {
  render() {
    const { filterField } = this.props;
    const content = filterField.radioButtons && filterField.radioButtons.map(
      (radioButton: FilterRadioButton, n: number) => {
        return <RadioButton key={n}
                            color="orange"
                            name={filterField.name}
                            value={radioButton.value}
                            selected={filterField.stateValue ? filterField.stateValue.value : ''}
                            handleChange={filterField.handler}>
          <FormattedMessage id={radioButton.labelIntl}>{
            txt => <span className={style.buttonLabel}>{txt}</span>
          }</FormattedMessage>
        </RadioButton>
      }
    );

    return (
      <article className={classNames(style.filterFieldWrap, style.radioGroupWrap)}>
        <FormattedMessage id={filterField.titleIntl}>{
          txt => <h2 className={classNames(style.filterTitle, { [style.open]: filterField.isOpen })}
                     onClick={filterField.handleOpen}>{txt}
            <i className={classNames(style.caret,
              { [icons.iconMinusLight]: filterField.isOpen },
              { [icons.iconPlusLight]: !filterField.isOpen })}/>
          </h2>
        }</FormattedMessage>
        {filterField.isOpen &&
        <section>
          {content}
        </section>}
      </article>
    );
  }
}

RadioType.propTypes = {
  filterField: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/Filter/RadioType/RadioType.jsx